import { StringMapping, ValueMapping } from "@opendaw/lib-std";
import { FieldAdapter } from "./FieldAdapter";
import { Propagation } from "@opendaw/lib-box";
export class PianoModeAdapter {
    #object;
    #keyboard;
    #timeRangeInQuarters;
    #noteScale;
    #noteLabels;
    #transpose;
    constructor(object) {
        this.#object = object;
        this.#keyboard = new FieldAdapter(this.#object.keyboard, ValueMapping.values([88, 76, 61, 49]), StringMapping.numeric({ fractionDigits: 1 }), "Keyboard Type");
        this.#timeRangeInQuarters = new FieldAdapter(this.#object.timeRangeInQuarters, ValueMapping.exponential(1, 64), StringMapping.numeric({ fractionDigits: 1 }), "Time-Range");
        this.#noteScale = new FieldAdapter(this.#object.noteScale, ValueMapping.exponential(0.5, 2.0), StringMapping.numeric({ fractionDigits: 1 }), "Note Scale");
        this.#noteLabels = new FieldAdapter(this.#object.noteLabels, ValueMapping.bool, StringMapping.bool, "Note Labels");
        this.#transpose = new FieldAdapter(this.#object.transpose, ValueMapping.linearInteger(-48, 48), StringMapping.numeric({ fractionDigits: 0 }), "Transpose");
    }
    subscribe(observer) {
        return this.#object.box.subscribe(Propagation.Children, () => observer(this));
    }
    get object() { return this.#object; }
    get keyboard() { return this.#keyboard; }
    get timeRangeInQuarters() { return this.#timeRangeInQuarters; }
    get noteScale() { return this.#noteScale; }
    get noteLabels() { return this.#noteLabels; }
    get transpose() { return this.#transpose; }
}
